import useApiFetch from '@/hooks/useApiFetch';
import { QueryKey } from 'react-query';

/**
 * Thin wrapper around useApiFetch for SEOx services that return plain data
 * (not AxiosResponse). Bridges the gap so consumers don't need `as any` hacks.
 */
export function useSeoFetch<T>(
  key: QueryKey,
  fetchFn: () => Promise<T>,
  options?: { enabled?: boolean; retry?: boolean }
) {
  const response = useApiFetch<T, void>(
    key,
    async () => {
      const data = await fetchFn();
      return { data } as any;
    },
    options
  );

  return {
    data: response.data as T | undefined,
    isLoading: response.isLoading,
    isError: response.isError,
    refetch: response.refetch,
  };
}
